import { DefaultErrorMessage, dialogErrorImage } from "@prismicio/editor-ui"

export function MediaLibraryRenderError() {
  return (
    <DefaultErrorMessage
      title="Oops! Something went wrong"
      description="An error occurred while searching for your image."
      errorImageSrc={dialogErrorImage}
      sx={{ marginBlock: "auto", marginInline: "auto" }}
    />
  )
}
